module.exports = __webpack_public_path__ + "assets/img/translation-case-2.15489dfd.png";